import React from 'react';
import useOptions from '../../hooks/useOptions';
import RadioGroupField from 'components/RadioGroupField';

import './HasGmField.styles.scss';
import './HasGmField.styles.responsive.scss';

const HasGmField: React.FC = () => {
  const { hasGmOptions } = useOptions();

  return (
    <div className="has-gm-field">
      <RadioGroupField name="hasGM" options={hasGmOptions} styled />
    </div>
  );
};

export default HasGmField;
